
import React from 'react';
import advSearchState from 'Stores/advSearch';
import { advSearchFilterPopupState } from 'Stores/advSearchFIlterPopup';
import { observer } from 'mobx-react';
// import { makeApi, URLS } from 'Utils/apiUtil';
import { ReactComponent as RadioInnerIcon } from '../../../../assets/svg/radio-inner-icon.svg';
import { ReactComponent as RadioOuterIcon } from '../../../../assets/svg/radio-outer-icon.svg';
import { ReactComponent as PlusIcon } from '../../../../assets/svg/plus-icon.svg';
import { ReactComponent as DownArrowIcon } from '../../../../assets/svg/down-arrow-icon.svg';

const ContactPerCompany = observer(props => {
  const { filterInPage = false } = props;
  const [showSuggestion, setShowSuggestion] = React.useState(false);

  let contactLimitsPerCompany = 0;
  const title = 'Contacts Per Company';

  if (filterInPage) 
    contactLimitsPerCompany = advSearchState.contactLimitsPerCompany;
   else 
    contactLimitsPerCompany = advSearchFilterPopupState.contactLimitsPerCompany;
  

  const onInputChange = (e, val) => {
    if (filterInPage) advSearchState.setContactLimitsPerCompany(val);
    else advSearchFilterPopupState.setContactLimitsPerCompany(val);
  };

  const onInputClick = e => {
    if (filterInPage) setShowSuggestion(!showSuggestion);
    else if (!showSuggestion) setShowSuggestion(true);
  };

  const closeSuggestion = () => {
    setShowSuggestion(false);
  };

  const contactLimit = [ { key:0, value:'No limit'},
  { key:1, value:'One contact'},
  { key:2, value:'Two contacts'},
  { key:3, value:'Three contacts'},
  { key:4, value:'Four contacts'},
  { key:5, value:'Five contacts'}];

  return (
    <div className="dropdown-section location-preference">
      <div className="location-preference-header" onClick={onInputClick}>
        {title}
        {filterInPage ? (
          <DownArrowIcon
            className={`dropdown-icon downarrow-icon plus-icon ${
              showSuggestion ? ' rotate-arrow' : ''
            }`}
            width={18}
            height={18}
          />
        ) : (
          <PlusIcon
            className="dropdown-icon plus-icon"
            width={18}
            height={18}
          />
        )}
      </div>
      <div
        className={`${
          filterInPage ? '' : 'suggestion-list'
        } radio-btn-wrap location-options animatedFast animatedDropDown ${
          showSuggestion ? '' : 'hide-suggestion'
        }`}
      >
        <div className="radio-wrapper">
        {contactLimit.map((data)=>{
          return (<div key = {data.key}
            className={`radio-item${
                contactLimitsPerCompany === data.key ? ' selected' : ''
            }`}
            onClick={e => onInputChange(e, data.key)}
          >
            <div className="radio-svg-section">
              <RadioInnerIcon className="radio-inner" viewBox="0 0 24 24" />
              <RadioOuterIcon className="radio-outer" viewBox="0 0 24 24" />
            </div>
            <div className="radio-text-new">{data.value}</div>
          </div>
          );
      })}
          
        </div>
      </div>
      {showSuggestion && !filterInPage && (
        <div className="suggestion-mask" onClick={closeSuggestion} />
      )}
    </div>
  );
});


export { ContactPerCompany };
export default ContactPerCompany;
